module.exports = __webpack_public_path__ + "static/media/anchor.7a206534.svg";